import { Injectable } from '@angular/core';
import { RestAPIService } from '../restAPI/rest-api.service';
import { MeetingNotesURLsService } from '../restAPI/meetingNotesURLs/meeting-notes-urls.service';

@Injectable({
  providedIn: 'root',
})
export class MeetingNotesService {
  constructor(
    private restApiService: RestAPIService,
    private meetingNotesURLs: MeetingNotesURLsService
  ) {}

  createMeetingNote(payload) {
    return this.restApiService.post(
      this.meetingNotesURLs.createMeetingNoteurl(),
      payload
    );
  }

  getAllMeetingNotesByIdAndYear(id, year) {
    return this.restApiService.get(
      this.meetingNotesURLs.getAllNotesById(id, year)
    );
  }

  deleteNotesById(id) {
    return this.restApiService.delete(this.meetingNotesURLs.deleteNoteById(id));
  }

  updateMeetingNote(id, payload) {
    return this.restApiService.put(
      this.meetingNotesURLs.updateNoteById(id),
      payload
    );
  }

  viewNoteById(id) {
    return this.restApiService.get(this.meetingNotesURLs.getNoteById(id));
  }

  getAllMeetingNotesForUserByYear(year) {
    return this.restApiService.get(
      this.meetingNotesURLs.getAllmeetingNotesForUser(year)
    );
  }
}
